<div class="inner-header left-header">
    <div class="logo d-flex align-items-center">
        <img [src]="'./assets/logo.png'" alt="image">
    </div>
    <ul class="nav align-items-center flex-nowrap d-none d-lg-flex d-xl-flex">
        <li *ngFor="let menu of menus">
            <a [routerLink]="menu.path" [queryParams]="{ section: menu.section || null }">{{menu.label | translate}}</a>
        </li>
    </ul>
    <div class="header-contact align-items-center nowrap pl-3 d-none d-xl-flex">
        <i class="fas fa-phone-square-alt"></i>
        +1 (703) 922-0777
    </div>
</div>
<div class="inner-header right-header">
    <div class="align-items-center d-none d-xl-flex">
        <button class="box-button button small nowrap" (click)="moveUrl('Locations')">{{ 'Make an Appointment' | translate }}</button>
    </div>
    <div class="d-flex align-items-center">
        <label id="select-lang-label" class="space-left-lg space-right-sm d-none d-lg-block d-xl-block mb-0">{{ 'Language' | translate }}</label>
        <i18n-translate></i18n-translate>
    </div>
    <button class="btn nav-menu-btn d-block d-lg-none d-xl-none" (click)="openNavMenu()">
        <i class="fas fa-bars"></i>
    </button>
</div>

<!--Mobile Nav Menu-->
<div class="d-block d-lg-none d-xl-none">
    <div class="mobile-nav" [ngClass]="{'active': openNav}">
        <ul class="nav">
            <li *ngFor="let menu of menus" [routerLink]="menu.path" [queryParams]="{ section: menu.section || null }" [ngClass]="{'active': getActiveMenu(menu) }" (click)="openNavMenu()">{{menu.label | translate}}</li>
        </ul>
    </div>
    <div class="mobile-nav-screen" [ngClass]="{'active': openNav}"></div>
</div>
